module.exports = __webpack_public_path__ + "img/1.dc36c3ef.jpg";